import React from 'react';
import { BrandFooter } from './BrandFooter';
import { LOGO_URL, WHATSAPP_MENSAJE, WHATSAPP_NUMERO, type Block } from '../utils/blocks';
interface ResultsOverlayProps {
  show: boolean;
  blocks: Block[];
  onClose: () => void;
  onReset: () => void;
}
export function ResultsOverlay({
  show,
  blocks,
  onClose,
  onReset
}: ResultsOverlayProps) {
  const crecH = blocks.filter(b => b.status === 'crecimiento').length * 0.5;
  const fugaH = blocks.filter(b => b.status === 'fuga').length * 0.5;
  const totalH = crecH + fugaH;
  const pctC = totalH ? Math.round(crecH / totalH * 100) : 0;
  const pctF = totalH ? 100 - pctC : 0;
  const fugas = blocks.filter(b => b.status === 'fuga');
  const waHref = WHATSAPP_NUMERO ? `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(WHATSAPP_MENSAJE)}` : '#';
  let cierre: React.ReactNode;
  if (fugaH >= 4) {
    cierre = <>
        Ayer se te fugaron <b data-id="element-56" data-mp="2xonb53s2b66x">{fugaH.toFixed(1)} horas</b> — horas que ya tenías,
        pero que no sumaron a tu crecimiento. Este es el mismo patrón que vemos
        en el 100% de los diagnósticos que hacemos: entre 4 y 6 horas diarias.
        Sostenido en el tiempo, eso no es solo tiempo perdido — es el nivel que
        no estás alcanzando porque una parte de tu esfuerzo diario no te está
        llevando a ningún lado. Vale la pena atenderlo ahora, antes de que se
        vuelva costumbre.
      </>;
  } else if (fugaH > 0) {
    cierre = <>
        Ayer se te fugaron <b data-id="element-57" data-mp="29jzofpp4f9lz">{fugaH.toFixed(1)} horas</b>. No es un número
        alarmante, pero vale la pena mirar en qué se fueron esos bloques — sobre
        todo si se repiten día tras día, porque ahí es donde un par de horas se
        convierten en semanas enteras.
      </>;
  } else {
    cierre = <>
        Ayer no marcaste fugas. Te recomendamos repetir este registro con el día
        de mañana para confirmar si se sostiene, o si ayer fue una excepción.
      </>;
  }
  return <div className={`overlay${show ? ' show' : ''}`} aria-hidden={!show} data-id="element-58" data-mp="s882htc2pei2">
      <div className="res-hero" data-id="element-59" data-mp="o7o30j411ysr">
        <img className="brand-logo" src={LOGO_URL} alt="Carolina Gómez" data-id="element-60" data-mp="o8fnoyw36c49" />
        <button type="button" className="res-close" onClick={onClose} data-id="element-61" data-mp="11zcfini6upa9">
          ← Volver al registro
        </button>
        <p className="eyebrow" data-id="element-62" data-mp="x71efhbpoxg4">Tu diagnóstico</p>
        <p className="res-big" data-id="element-63" data-mp="x69j87m111qd">{fugaH.toFixed(1)}h</p>
        <p className="res-big-label" data-id="element-64" data-mp="1bvxmhedrqagq">
          se te fugaron ayer en actividades que no generaron crecimiento real
          para tu negocio.
        </p>
        <div className="barra-prop" data-id="element-65" data-mp="1kxonw719zv4s">
          <div className="seg-c" style={{
          width: `${pctC}%`
        }} data-id="element-66" data-mp="1kwlyk3jlq0qz" />
          <div className="seg-f" style={{
          width: `${pctF}%`
        }} data-id="element-67" data-mp="1fykdxe6j1tde" />
        </div>
        <div className="prop-leyenda" data-id="element-68" data-mp="1fwhey4necpwj">
          <span data-id="element-69" data-mp="3moicfjt8rmox">Crecimiento {pctC}%</span>
          <span data-id="element-70" data-mp="3mpa6gq76xcd3">Fuga {pctF}%</span>
        </div>
      </div>

      <div className="res-body" data-id="element-71" data-mp="3hqqjcmgv1uj5">
        <div className="proy" data-id="element-72" data-mp="3hri4128x67un">
          <div className="card" data-id="element-73" data-mp="1x7wh39tzba1u">
            <div className="num" data-id="element-74" data-mp="1x7mqpl50v0vm">{(fugaH * 7).toFixed(0)}h</div>
            <div className="lab" data-id="element-75" data-mp="226znoyplxobx">Por semana</div>
          </div>
          <div className="card" data-id="element-76" data-mp="226hjnfwpe5tg">
            <div className="num" data-id="element-77" data-mp="1ofkrtralpsng">{(fugaH * 30).toFixed(0)}h</div>
            <div className="lab" data-id="element-78" data-mp="1of2wqxzodkh4">Por mes</div>
          </div>
        </div>

        <h3 data-id="element-79" data-mp="1sg4oyuv6cw9l">Dónde se fugaron tus horas</h3>
        <div data-id="element-80" data-mp="1sf3bkjqorxop">
          {fugas.length === 0 ? <p style={{
          fontSize: '13px',
          color: 'var(--gris)',
          padding: '12px 0'
        }} data-id="element-81" data-mp="1eh58wblq9pp1">
              No marcaste bloques como fuga ayer.
            </p> : fugas.map(b => <div className="fuga-item" key={b.id} data-id="element-82" data-mp="19hk079gra2z4">
                <span className="t" data-id="element-83" data-mp="19kelt4bi9tu4">{b.label}</span>
                <span className="a" data-id="element-84" data-mp="2zuhrrw8bq29l">{b.activity || '(sin descripción)'}</span>
              </div>)}
        </div>

        <div className="cierre" data-id="element-85" data-mp="33vjuwo5d2ygu">{cierre}</div>

        <a className="cta" href={waHref} target="_blank" rel="noopener noreferrer" data-id="element-86" data-mp="2f68kxb9tv1hp">
          Quiero cerrar estas fugas
        </a>
        <button type="button" className="reset-link" onClick={onReset} data-id="element-87" data-mp="2a7x8css5ecvs">
          Empezar un registro nuevo
        </button>

        <BrandFooter data-id="element-88" data-mp="259m18pt8mgh9" />
      </div>
    </div>;
}